import React, { useState } from "react";
import {
  useNotify,
  Edit,
  SaveButton,
  SimpleForm,
  Toolbar,
  TopToolbar,
  useRecordContext,
} from "react-admin";
import { BackButton } from "../../../components/common/BackButton";
import { ForceTitle } from "../../../components/common/ForceTitle";
import { logError } from "../../../utils/appUtils";
import { deepRedirect, getBackPath } from "../../../utils/utils";
import { ChecklistForm } from "./ChecklistForm";
import { DeleteChecklistButton } from "./DeleteChecklistButton";
import { validateChecklist } from "./ChecklistCreate";

const EditToolbar = (props) => {
  const notify = useNotify();
  const { backPath, history } = props;
  const [saving, setSaving] = useState(false);
  const record = useRecordContext();

  const onSuccess = () => {
    setSaving(false);
    notify(`Checklist updated successfully.`);
    deepRedirect(history, backPath);
  };

  const onFailure = (error) => {
    setSaving(false);
    logError("checklists:EditToolbar:onFailure", error, notify);
  };

  return (
    <Toolbar {...props} style={{ justifyContent: "space-between" }}>
      <SaveButton
        label="Save"
        disabled={props.pristine || saving}
        onSuccess={onSuccess}
        onFailure={onFailure}
      />
      <DeleteChecklistButton
        record={record}
        history={history}
        backPath={backPath}
        notify={notify}
      />
    </Toolbar>
  );
};

const EditActions = (props) => {
  return (
    <TopToolbar>
      <BackButton {...props} />
    </TopToolbar>
  );
};

export const ChecklistEdit = (props) => {
  const { history } = props;
  const backPath = getBackPath(props);

  return (
    <Edit
      {...props}
      title={<ForceTitle title="Edit Checklist" />}
      mutationMode="pessimistic"
      actions={<EditActions {...props} backPath={backPath} history={history} />}
    >
      <SimpleForm
        variant="outlined"
        submitOnEnter={false}
        validate={validateChecklist}
        toolbar={
          <EditToolbar {...props} backPath={backPath} history={history} />
        }
      >
        <ChecklistForm />
      </SimpleForm>
    </Edit>
  );
};
